import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent } from '@mui/material'
import ReportPreview from './ReportPreview'
import { useStyles } from '../CaseDiagnosisStyles'

export default function PreviewReport({ trfBarcode, handleClose, location, pdfUrl, setPdfUrl }) {
  const classes = useStyles()

  return (
    <>
      <Dialog
        open={true}
        onClose={handleClose}
        maxWidth="md"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        classes={{ paper: classes.previewDialogHeight }}
      >
        <ReportPreview
          trfBarcode={trfBarcode}
          location={location}
          pdfUrl={pdfUrl}
          setPdfUrl={setPdfUrl}
          isRelease={false}
        />
      </Dialog>
    </>
  )
}
